module.exports = __webpack_public_path__ + "static/media/similar-issue-white-icon.ce31506b.svg";